import { reactive } from "vue";

/** 创值规则（后台可配置，这里保存前端默认值，接口返回后覆盖） */
const DEFAULTS = {
  downloadCost: 2,
  signInReward: 5,
  publishReward: 10,
  // 平台下载权限开关（后台可配置）
  downloadEnabled: true,
  // 平台在线互动开关（后台可配置，与下载互不影响）
  playEnabled: true,
};

const config = reactive({ ...DEFAULTS });

export function setPointConfig(data) {
  if (data) {
    Object.assign(config, data);
  }
}

export function getPointConfig() {
  return config;
}

/** 下载 / 在线使用一个工具消耗的创值 */
export function getDownloadCost() {
  return config.downloadCost;
}

/** 平台是否开放下载文件（后台开关） */
export function isDownloadEnabled() {
  return config.downloadEnabled !== false;
}

/** 平台是否开放在线互动 / 在线使用（后台开关，与下载独立） */
export function isPlayEnabled() {
  return config.playEnabled !== false;
}

/**
 * 应用启动时加载一次创值规则（公开接口，失败则用默认值）
 */
export async function loadPointConfig(axiosInstance) {
  try {
    const res = await axiosInstance({ url: "point/config", method: "GET" });
    if (res && res.code === 200 && res.data) {
      setPointConfig(res.data);
    }
  } catch (e) {
    /* 静默失败，使用默认值 */
  }
  return config;
}
